// Currency for non-React code (analytics payload builders); ProductsProvider
// keeps it in sync with the currency of the loaded price data.
let currentCurrency = 'USD';

export const setCurrentCurrency = (code: string) => {
  if (code === currentCurrency) {
    return;
  }
  currentCurrency = code;

  // GTM tags should read the `currency` dataLayer variable instead of
  // hardcoding USD — revenue events can be in any market currency.
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'currencyChanged', currency: code });
  }
};

export const getCurrentCurrency = () => currentCurrency;
